import type { ICatalogo, IRespuestaApiLista } from "../../globales/interfaces";
import api from "../../utils/api";

export class EstadoTareaModelo {
    

    constructor() { }
    public async obtenerListaEstadosTarea(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/EstadoTareas/Listar`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

}

